import { render, staticRenderFns } from "./zhihuijiaotong.vue?vue&type=template&id=75241bce&scoped=true&"
import script from "./zhihuijiaotong.vue?vue&type=script&lang=js&"
export * from "./zhihuijiaotong.vue?vue&type=script&lang=js&"
import style0 from "./zhihuijiaotong.vue?vue&type=style&index=0&id=75241bce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75241bce",
  null
  
)

export default component.exports